export const BACKEND_API_GATEWAY_URL = 'https://treasury.cimas.co.zw:8010/api/v1/';
export const APP_CLIENT_ID = '93ed453e-b7ac-4192-a6d4-c45fae0d99ac';
export const APP_CLIENT_SECRET = 'panashe.devd123';
//https://treasury.cimas.co.zw:9010/api/v1/
//http://localhost:9010/api/v1/
//https://treasury.cimas.co.zw:8010/api/v1/